export default "__VITE_ASSET__LtY4aIe5__"